import React, { Fragment, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
// import { useSelector } from 'react-redux';
import { useMutation, useQuery } from "@apollo/client";
import styled from "styled-components";

import bagIcon from "../../../assets/images/sprites/Bag.svg";
// import { useInjectSaga } from 'utils/redux-injectors';
// import { sliceKey } from 'redux/Locker/slice';
// import { LockerSaga } from 'redux/Locker/saga';
// import { lockerSelector } from 'redux/Locker/selectors';
// import AddReviewModal from 'app/components/Modal/ResourceModal/AddResource';
// import { Resource } from 'app/components/Resource';
// import Review from 'app/components/Review';
import { Context } from "../../../context/globalContext";
import {
  GET_LOCKER_RESOURCES_BY_USER,
  GET_REVIEWS_BY_USER,
} from "../../../helpers/graphqlQueries";
import { ThemeProps } from "../../genericComponents/globalStyles";
import { useStorage } from "../../hook/useStorage";
import ImgLocker from "../../../assets/images/photos/img-locker.jpg";
import Rate from "antd/lib/rate";
import WriteReviewModal from "../../genericComponents/WriteReviewModal";
import { DELETE_FROM_LOCKER } from "../../../helpers/graphqlMutations";

export default function Locker({ email, owner }) {
  const {
    state: { user },
  } = useContext(Context);

  const {
    // loading: loadingReviews,
    data: reviewsResponse,
    refetch: refetchReviews
  } = useQuery(GET_REVIEWS_BY_USER, { variables: { userId: email || "" } });

  const {
    data: resourcesResponse,
    refetch: fetchResources,
  } = useQuery(GET_LOCKER_RESOURCES_BY_USER, {
    variables: { userId: email || "" },
  });

  const [modalVisibility, setModalVisibility] = useState(false);
  const [tabState, setTabState] = useState(0); // 0 => resource, 1 => review

  return (
    <Fragment>
      <section>
        <HeaderContainer>
          <LockerTitle>Locker</LockerTitle>
          <HeaderItemsContainers>
            <HeaderItem active={tabState === 0} onClick={() => setTabState(0)}>
              Resources
            </HeaderItem>
            <HeaderItem active={tabState === 1} onClick={() => setTabState(1)}>
              Reviews
            </HeaderItem>
          </HeaderItemsContainers>
          <div style={{ width: 100 }} />
        </HeaderContainer>
        <BodyContainer>
          {tabState === 0 ? (
            <RenderResources
              resources={resourcesResponse}
              refetch={fetchResources}
              owner={owner}
              user={user}
            />
          ) : (
              <RenderReviews reviews={reviewsResponse} owner={owner} setModalVisibility={setModalVisibility} />
            )}
        </BodyContainer>
      </section>
      <WriteReviewModal
        refetchReviews={refetchReviews}
        isShow={modalVisibility}
        onClose={() => setModalVisibility(false)}
        fromHome={true}
      />
    </Fragment>
  );
}

function RenderResources({ user, resources, refetch, owner }) {
  return (
    <>
      <ResourcesCard style={{alignItems:'center'}}>
        <img src={bagIcon} alt="bag" />
        <Textsubtitle>Browse all resources</Textsubtitle>
        <Line />
        <NavLink to={`/marketplace`}>
          <LinkText style={{margin:8}}>Go to Marketplace</LinkText>
        </NavLink>
      </ResourcesCard>
      {resources?.resources_locker?.map((res) => (
        <Resource
          key={res.resource_id}
          resourceId={res.resource_id}
          resource={res.resource_locker}
          user={user}
          refetch={refetch}
          owner={owner}
        />
      ))}
    </>
  );
}

function Resource({ user, resource, refetch, owner, resourceId }) {
  const [removeFromLocker] = useMutation(DELETE_FROM_LOCKER);
  const imageResource = useStorage(
    `resources/${resource?.picture_name ? resource.picture_name : ""}`
  );
  return (
    <ResourcesCard>
      <HeaderContainer>
        <ImageResource src={imageResource || ImgLocker} />
        <RateContainer>
          <NavLink to={`/product-page/${resourceId}`}>
            <LinkText>{resource.name}</LinkText>
          </NavLink>
          {resource.rating > 0 ? (
            <Rate disabled defaultValue={resource.rating} />
          ) : (
              <Textsubtitle>No review</Textsubtitle>
            )}
        </RateContainer>
      </HeaderContainer>
      <Line />
      {owner && (
        <ButtonOutline
          onClick={async () => {
            await removeFromLocker({
              variables: {
                user_id: user.email,
                resource_id: resourceId,
              },
            });
            refetch();
          }}
        >
          Remove from Locker
        </ButtonOutline>
      )}
    </ResourcesCard>
  );
}

function RenderReviews({ reviews, owner, setModalVisibility }) {
  return (
    <>
    {owner && (
        <ResourcesCard style={{alignItems:'center'}}>
          <Textsubtitle>Review a resource</Textsubtitle>
          <ButtonReview onClick={() => setModalVisibility(true)}>
            Start a review
          </ButtonReview>
        </ResourcesCard>
      )}
      {reviews?.users_reviews?.map((rev) => (
        <ResourcesCard>
          <div>
            <NavLink to={`/product-page/${rev.resource_id}`}>
              <ReviewTitle>{rev?.userReviewResource?.name}</ReviewTitle>
            </NavLink>
            <Rate disabled value={rev?.ReviewComment?.rating} />
            <Textsubtitle color={ThemeProps.color.darkGreen}>{rev?.ReviewComment?.title}</Textsubtitle>
            <Textsubtitle>{rev?.ReviewComment?.comment}</Textsubtitle>
          </div>
        </ResourcesCard>
      ))}
      {/* {owner&&(
        <CompleteRow>
          <Textsubtitle>Review a resource</Textsubtitle>
          <ButtonReview onClick={() => setModalVisibility(true)}>
            Start a review
          </ButtonReview>
        </CompleteRow>
      )} */}
    </>
  );
}

const ReviewTitle = styled.p`
  font-size: 1.5em;
`;
const ButtonReview = styled.button`
  background-color: ${ThemeProps.color.darkGreen};
  border-radius: 4px;
  margin-top: 8px;
  padding: 4px 32px;
  font-size: 1.4em;
  color: ${ThemeProps.color.white};
  outline: none;
  border: none;
`;
const ResourcesCard = styled.div`
  width: 40%;
  min-width: 290px;
  max-width: 340px;
  margin-top: 32px;
  padding: 16px 16px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
`;
const RateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const Textsubtitle = styled.p`
  font-size: 1.3em;
  margin-top: 8px;
  margin-bottom: 0px;
  color: ${p => p.color};
`;
const Line = styled.div`
  width: 100%;
  height: 1px;
  margin: 12px 0;
  background-color: ${ThemeProps.color.gabaYellow};
`;
const LinkText = styled.p`
  font-size: 1.2em;
`;
const ButtonOutline = styled.button`
  background: none;
  padding: 10px 14px;
  border-radius: 4px;
  font-size: 1.2em;
  outline: none;
  color: ${ThemeProps.color.darkGreen};
  border: solid 1px ${ThemeProps.color.darkGreen};
`;
const ImageResource = styled.img`
  max-height: 50px;
  max-width: 100px;
  width: auto;
  object-fit: contain;
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top:30px;
`;
const BodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const LockerTitle = styled.p`
  font-size: 2.4em;
  font-weight: bold;
`;
const HeaderItemsContainers = styled.div`
  display: flex;
`;
const HeaderItem = styled.button`
  height: 1.8em;
  padding: 0px 12px;
  font-size: 1.5em;
  border: none;
  background: none;
  border-bottom: 2px solid
    ${(p) => (p.active ? ThemeProps.color.gabaYellow : "#ddd")};
  outline: none;
`;

const CustomButton = styled.button`
  width: 168px;
  height: 36px;
  border-radius: 6px;
  border: solid 1px ${(props) => props.theme.color.gabaGreen};
  background-color: ${(props) => props.theme.color.gabaGreen};
  color: #ffffff;
`;
